/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import { createBrowserHistory } from 'history'

// setup history manually for export and use in http factory
export const basename = '/'
export const history = createBrowserHistory({ basename })
